import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LogoutIcon } from 'ressources/img/off.svg';

interface IProps {
    className?: string;
}

const Logout = ({ className }: IProps) => {
    const navigate = useNavigate();
    return (
        <LogoutIcon
            className={className}
            onClick={() => {
                navigate('/logout');
            }}
        />
    );
};

export default Logout;
